// @flow
import { DevicesActionTypes } from './constants';

type DevicesAction = { type: string, payload: {} | string };

// common success
export const devicesApiResponseSuccess = (actionType: string, data: any): DevicesAction => ({
    type: DevicesActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const devicesApiResponseError = (actionType: string, error: string): DevicesAction => ({
    type: DevicesActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getDevice = (id: string): DevicesAction => ({
    type: DevicesActionTypes.GET_DEVICE,
    payload: { id },
});

export const addDevice = (device:any):DevicesAction=>({
    type:DevicesActionTypes.ADD_DEVICE,
    payload:device
})
export const updateDevice = (device:any):DevicesAction=>({
    type:DevicesActionTypes.UPDATE_DEVICE,
    payload:device
})
export const deleteDevice = (device:any):DevicesAction=>({
    type:DevicesActionTypes.DELETE_DEVICE,
    payload:device
})

export const listDevices = (params:any): DevicesAction => ({
    type: DevicesActionTypes.LIST_DEVICES,
    payload: params,
});

export const listPlayers = (params:any): DevicesAction => ({
    type: DevicesActionTypes.LIST_PLAYERS,
    payload: params,
});

export const listInteractives = (params:any): DevicesAction => ({
    type: DevicesActionTypes.LIST_INTERACTIVES,
    payload: params,
});

export const resetDevices = (): DevicesAction => ({
    type: DevicesActionTypes.RESET,
    payload: {},
});

